import script from "./BoardState.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardState.vue?vue&type=script&setup=true&lang=ts"

import "./BoardState.vue?vue&type=style&index=0&id=76da1cf4&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76da1cf4"]])

export default __exports__